import React, {useEffect,useState,useRef} from "react";
import { Button, TextField } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from 'react-router-dom'

import Web3 from 'web3';
import WalletConnectProvider from "@walletconnect/web3-provider";

import $ from 'jquery';
import axios from 'axios';
import config from '../../lib/config';
import LoderImg from '../../assets/dev/images/loader.gif'
//import styles from "assets/jss/material-kit-react/views/landingPage.js";
import Modal from 'react-modal';
// https://data-seed-prebsc-1-s1.binance.org:8545/
import {
  AddLikeAction,
  GetLikeDataAction
} from '../../actions/v1/token';
import {
  AddressUserDetails_GetOrSave_Action,
  Collectibles_Get_Action,
  changeReceiptStatus_Action
} from '../../actions/v1/User';
import { toast } from 'react-toastify';
toast.configure();
let toasterOption = config.toasterOption;

//const useStyles = makeStyles(styles);

export default function ConnectWallet(props) {

  //const classes = useStyles();
  const { ...rest } = props;
  var wtype ="";

  const {
    WalletConnected
  } = props;

  const timerRef = useRef(null);

  useEffect(() => {
    getInit();
  }, []);
  async function getInit() {
    wtype = await localStorage.getItem("wtype");
    if(wtype){
    connect_Wallet(wtype);
    }else{
      toast.warn("Please connect wallet",toasterOption)
    }
  }

  let web3
  // head to blocknative.com to create a key
  const BLOCKNATIVE_KEY = 'blocknative-api-key'
  // the network id that your dapp runs on
  const NETWORK_ID = 1

  async function connect_Wallet(type) {
    window.$('.modal').modal('hide');
    
    
      if(type == 'wallet') {
        // var provider = new WalletConnectProvider({
        //   infuraId: "27e484dcd9e3efcfd25a83a78777cdf1",
        // });
        var provider = new WalletConnectProvider({
          rpc: {
            [config.livechainid]: config.liverpcUrls
          },
          chainId: config.livechainid
        });
      }
      else if(type == 'metamask') {
        var provider = window.ethereum;
        var web3 = new Web3(provider);
        if (typeof web3 !== 'undefined') {
          // 
        }
        else {
          props.Set_WalletConnected(false);
          toast.warning("Connect to Binance Network", toasterOption);
          return false;
        }
      }

      if (provider) {
        try {
          if(wtype =="metamask"){
          provider.enable()
          .then(async function () {
            const web3 = new Web3(window.web3.currentProvider)
            if(window.web3.currentProvider.networkVersion == config.networkVersion){
              if (window.web3.currentProvider.isMetaMask === true) {
                if(window.web3 && window.web3.eth && window.web3.eth.defaultAccount) {
                  var currAddr = window.web3.eth.defaultAccount;
                  props.Set_UserAccountAddr(currAddr);
                  props.Set_WalletConnected(true);
                  var result = await web3.eth.getAccounts()
                  var setacc = result[0];
                  props.Set_Accounts(setacc);
                  web3.eth.getBalance(setacc)
                  .then(val => {
                    var balance = val / 1000000000000000000;
                    props.Set_UserAccountBal(balance);
                    AfterWalletConnected();
                  })
                }
              }
            }
            else {
              props.Set_WalletConnected(false);
              toast.warning("Please Connect to Binance Network", toasterOption);
            }
          })
          .catch((e) => {
            props.Set_WalletConnected(false);
            toast.warning("Please Connect to Binance Network", toasterOption);
          })
        }
          else{
              console.log('wallet')
              var provider = new WalletConnectProvider({
                rpc: {
                  [config.livechainid]: config.liverpcUrls
                },
                chainId: config.livechainid
              });
              console.log(provider,'providerwallet')
              provider.on("connect", () => {
                setTimeout(() => window.$('#connect_wallet_modal').modal('hide'), 600);
                setTimeout(() => window.location.reload(false), 1200);
              });
              await provider.enable();
              var web3 = new Web3(provider);
              var network = await web3.eth.net.getId();
              var result = await web3.eth.getAccounts();
              console.log(result[0],'addresswallet')
              if (config.networkVersion == network) {
                props.Set_UserAccountAddr(result[0]);
                props.Set_WalletConnected(true);
                props.Set_Accounts(result[0]);
                // window.location.href="/home"
                web3.eth.getBalance(result[0])
                .then(val => {
                  var balance = val / 1000000000000000000;
                  props.Set_UserAccountBal(balance);
                  AfterWalletConnected();
                })
        
              } else {
                await provider.disconnect();
                toast.error('error', "please select binance chain network on your wallet", toasterOption);
              }
          }
        } catch (err) {
          props.Set_WalletConnected(false);
        }
      }
      else {
        props.Set_WalletConnected(false);
        toast.warning("Please Add Metamask External", toasterOption);
      }
    

  }
  async function AfterWalletConnected() {
    await AddressUserDetails_GetOrSave_Call();
    props.AfterWalletConnected();
  }
  async function AddressUserDetails_GetOrSave_Call() {
    var addr;
    if(wtype = "metamask"){
      addr = window.web3.eth.defaultAccount;
    }else{
      addr = await localStorage.getItem("address");
    }
    var ReqData = { addr : addr }
    var Resp = await AddressUserDetails_GetOrSave_Action(ReqData);
    console.log('------ 1q1q1q', Resp);
    if (Resp && Resp.data && Resp.data.data) {      
      props.Set_AddressUserDetails(Resp.data.data.User);
    } else {
      props.Set_AddressUserDetails({});
    }
    return true;
  }

  window.addEventListener('load', (event) => {
    event.preventDefault();
    console.log('addEventListener',event);
    if(window.ethereum) {
      window.ethereum.on('accountsChanged', function (accounts) {
        window.location.reload(false)
        if(timerRef.current) {
          clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
          connect_Wallet();
        }, 1000);
      })

      window.ethereum.on('networkChanged', function (networkId) {
        if(networkId == config.networkVersion){
          window.location.reload(false)

          if(timerRef.current) {
            clearTimeout(timerRef.current);
          }
          timerRef.current = setTimeout(() => {
            connect_Wallet();
          }, 1000);
          props.Set_WalletConnected(true);
        }
        else {
          props.Set_WalletConnected(false);
        }
      })
    }
  })

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  let subtitle;
  const [WalletConnectNotifyPopup, Set_WalletConnectNotifyPopup] = React.useState(false);

  function openModal() {
    Set_WalletConnectNotifyPopup(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#f00';
  }

  function closeModal() {
    Set_WalletConnectNotifyPopup(false);
  }

  var WalletConnectNotifyPopup_test = '';

  if(WalletConnected) {
    WalletConnectNotifyPopup_test = false;
  }
  else {
    WalletConnectNotifyPopup_test = true;
  }

  var pathVal = '';

  const location = useLocation();
  if(location.pathname) {
    if(location.pathname.split('/').length >= 2) {
      pathVal = location.pathname.split('/')[1];
    }
  }

  const [location_pathname, Set_location_pathname] = useState(pathVal);

  const connect_Wallet_call = (type) => {
    // if(WalletConnected!=true) {
    //   connect_Wallet(type);
    // }
  }

  return (
    <div>
      {props.fullLoader && <div class="loading"></div>}
      {/* {(
        (WalletConnected == false || WalletConnected == 'false')
        &&
        (
          location_pathname == 'my-items'
          || location_pathname == 'following'
          || location_pathname == 'activity'
          || location_pathname == 'info'
        )
      ) &&
      <Modal
        isOpen={true}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="modaltest" style={{opacity:2, position:'relative'}}>
          <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Network</h2>
          <div>Connect to Binance Network.</div>
        </div>
      </Modal>
      } */}
      <div id="connect_Wallet_call" onClick={() => connect_Wallet_call('metamask')}></div>
    </div>
  )
}